// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Role_Administrator
 * @header lbServices.Role_Administrator
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role_Administrator` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role_Administrator",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/role-administrator/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role_Administrator.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/role-administrator/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Administrator#me
             * @methodOf lbServices.Role_Administrator
             *
             * @description
             *
             * Get user's administrative settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Administrator` object.)
             * </em>
             */
            "me": {
              url: urlBase + "/role-administrator/me",
              method: "POST",
            },

            // INTERNAL. Use Account.administrator() instead.
            "::get::Account::administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "GET",
            },

            // INTERNAL. Use Account.administrator.create() instead.
            "::create::Account::administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Account.administrator.createMany() instead.
            "::createMany::Account::administrator": {
              isArray: true,
              url: urlBase + "/account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Account.administrator.update() instead.
            "::update::Account::administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "PUT",
            },

            // INTERNAL. Use Account.administrator.destroy() instead.
            "::destroy::Account::administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Role_Administrator#modelName
        * @propertyOf lbServices.Role_Administrator
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role_Administrator`.
        */
        R.modelName = "Role_Administrator";


            /**
             * @ngdoc method
             * @name lbServices.Role_Administrator#account
             * @methodOf lbServices.Role_Administrator
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role_Administrator id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::Role_Administrator::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Role_Account_Manager
 * @header lbServices.Role_Account_Manager
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role_Account_Manager` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role_Account_Manager",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/role-account-manager/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role_Account_Manager.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/role-account-manager/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#activate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "activate": {
              url: urlBase + "/role-account-manager/activate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#activities
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get latest activities of a specified account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `skip` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "activities": {
              url: urlBase + "/role-account-manager/activities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#changePassword
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Change password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "changePassword": {
              url: urlBase + "/role-account-manager/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#clearLimits
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Clear account limits
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "clearLimits": {
              url: urlBase + "/role-account-manager/clear-limits",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#deactivate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Deactivate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "deactivate": {
              url: urlBase + "/role-account-manager/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#filter
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Filter accounts by given options
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "filter": {
              url: urlBase + "/role-account-manager/filter",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#get
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get user's administrative settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "get": {
              url: urlBase + "/role-account-manager/get",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#new
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Create user with email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/role-account-manager/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#recent
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get recently created accounts
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `limit` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "recent": {
              url: urlBase + "/role-account-manager/recent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#search
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Find a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/role-account-manager/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#total
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get number of accounts created
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "total": {
              url: urlBase + "/role-account-manager/total",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#update
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "update": {
              url: urlBase + "/role-account-manager/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#tokenList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * List all tokens of the specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "tokenList": {
              url: urlBase + "/role-account-manager/token-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#tokenRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Remove a token of the specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "tokenRemove": {
              url: urlBase + "/role-account-manager/token-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#certAdd
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "certAdd": {
              url: urlBase + "/role-account-manager/cert-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#certList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * List the certificates of a specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "certList": {
              url: urlBase + "/role-account-manager/cert-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#certRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Remove a certificate from a scpecified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `certId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "certRemove": {
              url: urlBase + "/role-account-manager/cert-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#certUpdate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "certUpdate": {
              url: urlBase + "/role-account-manager/cert-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#ipAdd
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Add an IP to whitelist when loging in
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `title` – `{string}` -
             *
             *  - `address` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "ipAdd": {
              url: urlBase + "/role-account-manager/ip-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#ipList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * List the ip whitelist of a specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "ipList": {
              url: urlBase + "/role-account-manager/ip-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#ipRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Remove an IP from the account's whitelist
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `ipId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "ipRemove": {
              url: urlBase + "/role-account-manager/ip-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#sshAdd
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `title` – `{string}` -
             *
             *  - `content` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "sshAdd": {
              url: urlBase + "/role-account-manager/ssh-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#sshList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "sshList": {
              url: urlBase + "/role-account-manager/ssh-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#sshRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Remove SSH Key from account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `keyId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "sshRemove": {
              url: urlBase + "/role-account-manager/ssh-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#roleAdd
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "roleAdd": {
              url: urlBase + "/role-account-manager/role-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#roleEdit
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `roleName` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "roleEdit": {
              url: urlBase + "/role-account-manager/role-edit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#roleGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `roleName` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "roleGet": {
              url: urlBase + "/role-account-manager/role-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#roles
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get all roles an account can have
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "roles": {
              isArray: true,
              url: urlBase + "/role-account-manager/roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#roleRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "roleRemove": {
              url: urlBase + "/role-account-manager/role-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#mediaUpload
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "mediaUpload": {
              url: urlBase + "/role-account-manager/media-upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#mediaGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `location` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "mediaGet": {
              url: urlBase + "/role-account-manager/media-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#mediaUpdate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `location` – `{string}` -
             *
             *  - `privacy` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "mediaUpdate": {
              url: urlBase + "/role-account-manager/media-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#teamMemberUpdate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "teamMemberUpdate": {
              url: urlBase + "/role-account-manager/team-member-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#teamMemberGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "teamMemberGet": {
              url: urlBase + "/role-account-manager/team-member-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#memberGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Topup account with coins
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "memberGet": {
              url: urlBase + "/role-account-manager/member-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#topupGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "topupGet": {
              url: urlBase + "/role-account-manager/topup-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#topupSubmit
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Topup account with coins
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `amount` – `{number=}` -
             *
             *  - `coins` – `{number}` -
             *
             *  - `free` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "topupSubmit": {
              url: urlBase + "/role-account-manager/topup-submit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#topupList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "topupList": {
              url: urlBase + "/role-account-manager/topup-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#topupRemove
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Cancel a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "topupRemove": {
              url: urlBase + "/role-account-manager/topup-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#topupRecover
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Recover a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "topupRecover": {
              url: urlBase + "/role-account-manager/topup-recover",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#usageList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "usageList": {
              url: urlBase + "/role-account-manager/usage-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#invoiceGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get a invoice from a customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "invoiceGet": {
              url: urlBase + "/role-account-manager/invoice-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#invoiceList
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get invoices from customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "invoiceList": {
              url: urlBase + "/role-account-manager/invoice-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#invoicePaymentAdd
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Update a invoice
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `invoiceId` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `amount` – `{number}` -
             *
             *  - `currency` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "invoicePaymentAdd": {
              url: urlBase + "/role-account-manager/invoice-payment-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#invoicePaymentUpdate
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Cancel a payment invoice
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `status` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "invoicePaymentUpdate": {
              url: urlBase + "/role-account-manager/invoice-payment-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#customerGet
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Get customer details
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "customerGet": {
              url: urlBase + "/role-account-manager/customer-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#customerAnalytics
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Analyze customer stats
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
            "customerAnalytics": {
              url: urlBase + "/role-account-manager/customer-analytics",
              method: "POST",
            },

            // INTERNAL. Use Account.account_manager() instead.
            "::get::Account::account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "GET",
            },

            // INTERNAL. Use Account.account_manager.create() instead.
            "::create::Account::account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Account.account_manager.createMany() instead.
            "::createMany::Account::account_manager": {
              isArray: true,
              url: urlBase + "/account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Account.account_manager.update() instead.
            "::update::Account::account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "PUT",
            },

            // INTERNAL. Use Account.account_manager.destroy() instead.
            "::destroy::Account::account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Role_Account_Manager#modelName
        * @propertyOf lbServices.Role_Account_Manager
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role_Account_Manager`.
        */
        R.modelName = "Role_Account_Manager";


            /**
             * @ngdoc method
             * @name lbServices.Role_Account_Manager#account
             * @methodOf lbServices.Role_Account_Manager
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role_Account_Manager id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::Role_Account_Manager::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Role_Team_Member
 * @header lbServices.Role_Team_Member
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role_Team_Member` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role_Team_Member",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/role-team-member/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role_Team_Member.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/role-team-member/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Account.team_member() instead.
            "::get::Account::team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "GET",
            },

            // INTERNAL. Use Account.team_member.create() instead.
            "::create::Account::team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Account.team_member.createMany() instead.
            "::createMany::Account::team_member": {
              isArray: true,
              url: urlBase + "/account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Account.team_member.update() instead.
            "::update::Account::team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "PUT",
            },

            // INTERNAL. Use Account.team_member.destroy() instead.
            "::destroy::Account::team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Role_Team_Member#modelName
        * @propertyOf lbServices.Role_Team_Member
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role_Team_Member`.
        */
        R.modelName = "Role_Team_Member";


            /**
             * @ngdoc method
             * @name lbServices.Role_Team_Member#account
             * @methodOf lbServices.Role_Team_Member
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role_Team_Member id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::Role_Team_Member::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Role_Editor
 * @header lbServices.Role_Editor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role_Editor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role_Editor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/role-editor/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role_Editor.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/role-editor/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role_Editor#contentChange
             * @methodOf lbServices.Role_Editor
             *
             * @description
             *
             * Change content by given data
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Editor` object.)
             * </em>
             */
            "contentChange": {
              url: urlBase + "/role-editor/content-change",
              method: "GET",
            },

            // INTERNAL. Use Account.editor() instead.
            "::get::Account::editor": {
              url: urlBase + "/account/:id/editor",
              method: "GET",
            },

            // INTERNAL. Use Account.editor.create() instead.
            "::create::Account::editor": {
              url: urlBase + "/account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Account.editor.createMany() instead.
            "::createMany::Account::editor": {
              isArray: true,
              url: urlBase + "/account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Account.editor.update() instead.
            "::update::Account::editor": {
              url: urlBase + "/account/:id/editor",
              method: "PUT",
            },

            // INTERNAL. Use Account.editor.destroy() instead.
            "::destroy::Account::editor": {
              url: urlBase + "/account/:id/editor",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Role_Editor#modelName
        * @propertyOf lbServices.Role_Editor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role_Editor`.
        */
        R.modelName = "Role_Editor";


            /**
             * @ngdoc method
             * @name lbServices.Role_Editor#account
             * @methodOf lbServices.Role_Editor
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role_Editor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::Role_Editor::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Contact_Email
 * @header lbServices.Contact_Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Contact_Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Contact_Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/contact-email/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#inboxList
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Return inbox
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `addressId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "inboxList": {
              url: urlBase + "/contact-email/inbox-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#inboxLoad
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Load email from inbox
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `emailId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "inboxLoad": {
              url: urlBase + "/contact-email/inbox-load",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#inboxAccounts
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Return inbox accounts
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "inboxAccounts": {
              url: urlBase + "/contact-email/inbox-accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#templateList
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Return all email templates
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "templateList": {
              url: urlBase + "/contact-email/template-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#templateRender
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Render an email template
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `lng` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "templateRender": {
              url: urlBase + "/contact-email/template-render",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact_Email#send
             * @methodOf lbServices.Contact_Email
             *
             * @description
             *
             * Send an email to a contact
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `to` – `{*}` -
             *
             *  - `subject` – `{string=}` -
             *
             *  - `message` – `{string}` -
             *
             *  - `attachments` – `{*=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact_Email` object.)
             * </em>
             */
            "send": {
              url: urlBase + "/contact-email/send",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Contact_Email#modelName
        * @propertyOf lbServices.Contact_Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Contact_Email`.
        */
        R.modelName = "Contact_Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Account
 * @header lbServices.Account
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Account` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Account",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/account/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Account.administrator() instead.
            "prototype$__get__administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "GET",
            },

            // INTERNAL. Use Account.administrator.create() instead.
            "prototype$__create__administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Account.administrator.update() instead.
            "prototype$__update__administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "PUT",
            },

            // INTERNAL. Use Account.administrator.destroy() instead.
            "prototype$__destroy__administrator": {
              url: urlBase + "/account/:id/administrator",
              method: "DELETE",
            },

            // INTERNAL. Use Account.account_manager() instead.
            "prototype$__get__account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "GET",
            },

            // INTERNAL. Use Account.account_manager.create() instead.
            "prototype$__create__account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Account.account_manager.update() instead.
            "prototype$__update__account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "PUT",
            },

            // INTERNAL. Use Account.account_manager.destroy() instead.
            "prototype$__destroy__account_manager": {
              url: urlBase + "/account/:id/account_manager",
              method: "DELETE",
            },

            // INTERNAL. Use Account.team_member() instead.
            "prototype$__get__team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "GET",
            },

            // INTERNAL. Use Account.team_member.create() instead.
            "prototype$__create__team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Account.team_member.update() instead.
            "prototype$__update__team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "PUT",
            },

            // INTERNAL. Use Account.team_member.destroy() instead.
            "prototype$__destroy__team_member": {
              url: urlBase + "/account/:id/team_member",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__get__reviewer
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches hasOne relation reviewer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__get__reviewer": {
              url: urlBase + "/account/:id/reviewer",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__create__reviewer
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Creates a new instance in reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__create__reviewer": {
              url: urlBase + "/account/:id/reviewer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__update__reviewer
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__update__reviewer": {
              url: urlBase + "/account/:id/reviewer",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__destroy__reviewer
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Deletes reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroy__reviewer": {
              url: urlBase + "/account/:id/reviewer",
              method: "DELETE",
            },

            // INTERNAL. Use Account.editor() instead.
            "prototype$__get__editor": {
              url: urlBase + "/account/:id/editor",
              method: "GET",
            },

            // INTERNAL. Use Account.editor.create() instead.
            "prototype$__create__editor": {
              url: urlBase + "/account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Account.editor.update() instead.
            "prototype$__update__editor": {
              url: urlBase + "/account/:id/editor",
              method: "PUT",
            },

            // INTERNAL. Use Account.editor.destroy() instead.
            "prototype$__destroy__editor": {
              url: urlBase + "/account/:id/editor",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#login
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/account/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#logout
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/account/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$verify
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/account/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#confirm
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/account/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#resetPassword
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/account/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#changePassword
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/account/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#setPassword
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/account/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#hasRoles
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Check if a user has any of the requested roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roles` – `{*}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "hasRoles": {
              url: urlBase + "/account/has-roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#activities
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Get latest activities of authenticated user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `skip` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "activities": {
              url: urlBase + "/account/activities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#passwordChange
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Change password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password_old` – `{string=}` -
             *
             *  - `password_new` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "passwordChange": {
              url: urlBase + "/account/password-change",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#deactivate
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "deactivate": {
              url: urlBase + "/account/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#me
             * @methodOf lbServices.Account
             *
             * @description
             *
             * View current user profile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "me": {
              url: urlBase + "/account/me",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#recover
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "recover": {
              url: urlBase + "/account/recover",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#requestPassword
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `callback` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "requestPassword": {
              url: urlBase + "/account/request-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#requestRecovery
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "requestRecovery": {
              url: urlBase + "/account/request-recovery",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#resendVerification
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Send verification letter to the given email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "resendVerification": {
              url: urlBase + "/account/resend-verification",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#signedIn
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Check if user is signed in.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "signedIn": {
              url: urlBase + "/account/signed-in",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#signIn
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Login account using email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string=}` -
             *
             *  - `username` – `{string=}` -
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "signIn": {
              url: urlBase + "/account/sign-in",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#signOut
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Logout a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "signOut": {
              url: urlBase + "/account/sign-out",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#signOutAll
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Clear all tokens from this account
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "signOutAll": {
              url: urlBase + "/account/sign-out-all",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#roleList
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "roleList": {
              url: urlBase + "/account/role-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#roleGet
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roleName` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "roleGet": {
              url: urlBase + "/account/role-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#verifyEmail
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Confirm a account registration with uid verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "verifyEmail": {
              url: urlBase + "/account/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#mediaUpdate
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Set privacy for account media file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `privacy` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "mediaUpdate": {
              url: urlBase + "/account/media-privacy",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#mediaUpload
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Upload an account media file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "mediaUpload": {
              url: urlBase + "/account/media-upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#mediaGet
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Get a media file from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "mediaGet": {
              url: urlBase + "/account/media-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#update
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "update": {
              url: urlBase + "/account/update",
              method: "POST",
            },

            // INTERNAL. Use Role_Administrator.account() instead.
            "::get::Role_Administrator::account": {
              url: urlBase + "/role-administrator/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Role_Account_Manager.account() instead.
            "::get::Role_Account_Manager::account": {
              url: urlBase + "/role-account-manager/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Role_Team_Member.account() instead.
            "::get::Role_Team_Member::account": {
              url: urlBase + "/role-team-member/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Role_Editor.account() instead.
            "::get::Role_Editor::account": {
              url: urlBase + "/role-editor/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#getCurrent
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/account" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



        /**
         * @ngdoc method
         * @name lbServices.Account#getCachedCurrent
         * @methodOf lbServices.Account
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Account#login} or
         * {@link lbServices.Account#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Account instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Account#isAuthenticated
         * @methodOf lbServices.Account
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Account#getCurrentId
         * @methodOf lbServices.Account
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Account#modelName
        * @propertyOf lbServices.Account
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Account`.
        */
        R.modelName = "Account";

    /**
     * @ngdoc object
     * @name lbServices.Account.administrator
     * @header lbServices.Account.administrator
     * @object
     * @description
     *
     * The object `Account.administrator` groups methods
     * manipulating `Role_Administrator` instances related to `Account`.
     *
     * Call {@link lbServices.Account#administrator Account.administrator()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Account#administrator
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches hasOne relation administrator.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Administrator` object.)
             * </em>
             */
        R.administrator = function() {
          var TargetResource = $injector.get("Role_Administrator");
          var action = TargetResource["::get::Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.administrator#create
             * @methodOf lbServices.Account.administrator
             *
             * @description
             *
             * Creates a new instance in administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Administrator` object.)
             * </em>
             */
        R.administrator.create = function() {
          var TargetResource = $injector.get("Role_Administrator");
          var action = TargetResource["::create::Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.administrator#createMany
             * @methodOf lbServices.Account.administrator
             *
             * @description
             *
             * Creates a new instance in administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Administrator` object.)
             * </em>
             */
        R.administrator.createMany = function() {
          var TargetResource = $injector.get("Role_Administrator");
          var action = TargetResource["::createMany::Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.administrator#destroy
             * @methodOf lbServices.Account.administrator
             *
             * @description
             *
             * Deletes administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.administrator.destroy = function() {
          var TargetResource = $injector.get("Role_Administrator");
          var action = TargetResource["::destroy::Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.administrator#update
             * @methodOf lbServices.Account.administrator
             *
             * @description
             *
             * Update administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Administrator` object.)
             * </em>
             */
        R.administrator.update = function() {
          var TargetResource = $injector.get("Role_Administrator");
          var action = TargetResource["::update::Account::administrator"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Account.account_manager
     * @header lbServices.Account.account_manager
     * @object
     * @description
     *
     * The object `Account.account_manager` groups methods
     * manipulating `Role_Account_Manager` instances related to `Account`.
     *
     * Call {@link lbServices.Account#account_manager Account.account_manager()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Account#account_manager
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches hasOne relation account_manager.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager = function() {
          var TargetResource = $injector.get("Role_Account_Manager");
          var action = TargetResource["::get::Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.account_manager#create
             * @methodOf lbServices.Account.account_manager
             *
             * @description
             *
             * Creates a new instance in account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.create = function() {
          var TargetResource = $injector.get("Role_Account_Manager");
          var action = TargetResource["::create::Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.account_manager#createMany
             * @methodOf lbServices.Account.account_manager
             *
             * @description
             *
             * Creates a new instance in account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.createMany = function() {
          var TargetResource = $injector.get("Role_Account_Manager");
          var action = TargetResource["::createMany::Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.account_manager#destroy
             * @methodOf lbServices.Account.account_manager
             *
             * @description
             *
             * Deletes account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.account_manager.destroy = function() {
          var TargetResource = $injector.get("Role_Account_Manager");
          var action = TargetResource["::destroy::Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.account_manager#update
             * @methodOf lbServices.Account.account_manager
             *
             * @description
             *
             * Update account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.update = function() {
          var TargetResource = $injector.get("Role_Account_Manager");
          var action = TargetResource["::update::Account::account_manager"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Account.team_member
     * @header lbServices.Account.team_member
     * @object
     * @description
     *
     * The object `Account.team_member` groups methods
     * manipulating `Role_Team_Member` instances related to `Account`.
     *
     * Call {@link lbServices.Account#team_member Account.team_member()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Account#team_member
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches hasOne relation team_member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Team_Member` object.)
             * </em>
             */
        R.team_member = function() {
          var TargetResource = $injector.get("Role_Team_Member");
          var action = TargetResource["::get::Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.team_member#create
             * @methodOf lbServices.Account.team_member
             *
             * @description
             *
             * Creates a new instance in team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Team_Member` object.)
             * </em>
             */
        R.team_member.create = function() {
          var TargetResource = $injector.get("Role_Team_Member");
          var action = TargetResource["::create::Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.team_member#createMany
             * @methodOf lbServices.Account.team_member
             *
             * @description
             *
             * Creates a new instance in team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Team_Member` object.)
             * </em>
             */
        R.team_member.createMany = function() {
          var TargetResource = $injector.get("Role_Team_Member");
          var action = TargetResource["::createMany::Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.team_member#destroy
             * @methodOf lbServices.Account.team_member
             *
             * @description
             *
             * Deletes team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.team_member.destroy = function() {
          var TargetResource = $injector.get("Role_Team_Member");
          var action = TargetResource["::destroy::Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.team_member#update
             * @methodOf lbServices.Account.team_member
             *
             * @description
             *
             * Update team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Team_Member` object.)
             * </em>
             */
        R.team_member.update = function() {
          var TargetResource = $injector.get("Role_Team_Member");
          var action = TargetResource["::update::Account::team_member"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Account.editor
     * @header lbServices.Account.editor
     * @object
     * @description
     *
     * The object `Account.editor` groups methods
     * manipulating `Role_Editor` instances related to `Account`.
     *
     * Call {@link lbServices.Account#editor Account.editor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Account#editor
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches hasOne relation editor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Editor` object.)
             * </em>
             */
        R.editor = function() {
          var TargetResource = $injector.get("Role_Editor");
          var action = TargetResource["::get::Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.editor#create
             * @methodOf lbServices.Account.editor
             *
             * @description
             *
             * Creates a new instance in editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Editor` object.)
             * </em>
             */
        R.editor.create = function() {
          var TargetResource = $injector.get("Role_Editor");
          var action = TargetResource["::create::Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.editor#createMany
             * @methodOf lbServices.Account.editor
             *
             * @description
             *
             * Creates a new instance in editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Editor` object.)
             * </em>
             */
        R.editor.createMany = function() {
          var TargetResource = $injector.get("Role_Editor");
          var action = TargetResource["::createMany::Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.editor#destroy
             * @methodOf lbServices.Account.editor
             *
             * @description
             *
             * Deletes editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.editor.destroy = function() {
          var TargetResource = $injector.get("Role_Editor");
          var action = TargetResource["::destroy::Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Account.editor#update
             * @methodOf lbServices.Account.editor
             *
             * @description
             *
             * Update editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role_Editor` object.)
             * </em>
             */
        R.editor.update = function() {
          var TargetResource = $injector.get("Role_Editor");
          var action = TargetResource["::update::Account::editor"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Activity_Item
 * @header lbServices.Activity_Item
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Activity_Item` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Activity_Item",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activity-item/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Activity_Item#details
             * @methodOf lbServices.Activity_Item
             *
             * @description
             *
             * Get Activity by ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Item` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/activity-item/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity_Item#latest
             * @methodOf lbServices.Activity_Item
             *
             * @description
             *
             * Get Latest number of activities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string=}` -
             *
             *  - `unit` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `skip` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Item` object.)
             * </em>
             */
            "latest": {
              url: urlBase + "/activity-item/latest",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Activity_Item#modelName
        * @propertyOf lbServices.Activity_Item
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Activity_Item`.
        */
        R.modelName = "Activity_Item";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Activity_Feed
 * @header lbServices.Activity_Feed
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Activity_Feed` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Activity_Feed",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activity-feed/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Activity_Feed#getByType
             * @methodOf lbServices.Activity_Feed
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Feed` object.)
             * </em>
             */
            "getByType": {
              isArray: true,
              url: urlBase + "/activity-feed/get-by-type",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Activity_Feed#modelName
        * @propertyOf lbServices.Activity_Feed
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Activity_Feed`.
        */
        R.modelName = "Activity_Feed";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Activity_Count
 * @header lbServices.Activity_Count
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Activity_Count` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Activity_Count",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activity-count/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Activity_Count#details
             * @methodOf lbServices.Activity_Count
             *
             * @description
             *
             * Get Count Details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Count` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/activity-count/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity_Count#totalsByType
             * @methodOf lbServices.Activity_Count
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Count` object.)
             * </em>
             */
            "totalsByType": {
              url: urlBase + "/activity-count/totals-by-type",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity_Count#totals
             * @methodOf lbServices.Activity_Count
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity_Count` object.)
             * </em>
             */
            "totals": {
              url: urlBase + "/activity-count/totals",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Activity_Count#modelName
        * @propertyOf lbServices.Activity_Count
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Activity_Count`.
        */
        R.modelName = "Activity_Count";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.System
 * @header lbServices.System
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `System` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "System",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/system/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.System#clusters
             * @methodOf lbServices.System
             *
             * @description
             *
             * Get clusters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `System` object.)
             * </em>
             */
            "clusters": {
              url: urlBase + "/system/clusters",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.System#modelName
        * @propertyOf lbServices.System
        * @description
        * The name of the model represented by this $resource,
        * i.e. `System`.
        */
        R.modelName = "System";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Process
 * @header lbServices.Process
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Process` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Process",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/process/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Process#logs
             * @methodOf lbServices.Process
             *
             * @description
             *
             * Get application logs
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Process` object.)
             * </em>
             */
            "logs": {
              url: urlBase + "/process/logs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Process#restart
             * @methodOf lbServices.Process
             *
             * @description
             *
             * Restart system
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Process` object.)
             * </em>
             */
            "restart": {
              url: urlBase + "/process/restart",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Process#changesList
             * @methodOf lbServices.Process
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Process` object.)
             * </em>
             */
            "changesList": {
              url: urlBase + "/process/changes-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Process#changesRefresh
             * @methodOf lbServices.Process
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Process` object.)
             * </em>
             */
            "changesRefresh": {
              url: urlBase + "/process/changes-refresh",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Process#modelName
        * @propertyOf lbServices.Process
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Process`.
        */
        R.modelName = "Process";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Page
 * @header lbServices.Page
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Page` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Page",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/page/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Page#loadTemplate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/page/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#loadTemplates
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/page/load-templates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#loadCommit
             * @methodOf lbServices.Page
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/page/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#loadOne
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Load page with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/page/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#delete
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/page/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#save
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Save page data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/page/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#new
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `title` – `{string}` -
             *
             *  - `path` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/page/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#loadMany
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Load all pages by template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/page/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#loadTemplate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/page/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#searchKeywords
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Get search keywords for fuzzy search on the client side
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "searchKeywords": {
              isArray: true,
              url: urlBase + "/page/search-keywords",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#search
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Search for a page using fuzzy search capabilities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `text` – `{string}` -
             *
             *  - `keywords` – `{*}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/page/search",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Page#modelName
        * @propertyOf lbServices.Page
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Page`.
        */
        R.modelName = "Page";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Media
 * @header lbServices.Media
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Media` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Media",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/media/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Media#deleteObject
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Delete an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "deleteObject": {
              url: urlBase + "/media/delete-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#details
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Get a file details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `location` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/media/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#list
             * @methodOf lbServices.Media
             *
             * @description
             *
             * List the files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `dir` – `{string=}` -
             *
             *  - `marker` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "list": {
              url: urlBase + "/media/list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#newFolder
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Upload a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "newFolder": {
              url: urlBase + "/media/new-folder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#updateFile
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/media/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#updateFile
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/media/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#copyObject
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Copy an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "copyObject": {
              url: urlBase + "/media/copy-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#moveObject
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Move an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "moveObject": {
              url: urlBase + "/media/move-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#uploadFile
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/media/upload-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#uploadFiles
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Upload an array of files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "uploadFiles": {
              url: urlBase + "/media/upload-files",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#searchKeywords
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Get search keywords for fuzzy search on the client side
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "searchKeywords": {
              isArray: true,
              url: urlBase + "/media/search-keywords",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media#search
             * @methodOf lbServices.Media
             *
             * @description
             *
             * Search for a page using fuzzy search capabilities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `text` – `{string}` -
             *
             *  - `keywords` – `{*}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/media/search",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Media#modelName
        * @propertyOf lbServices.Media
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Media`.
        */
        R.modelName = "Media";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Media_Private
 * @header lbServices.Media_Private
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Media_Private` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Media_Private",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/media-private/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#deleteObject
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Delete an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "deleteObject": {
              url: urlBase + "/media-private/delete-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#details
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Get a file details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `location` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/media-private/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#list
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * List the files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `dir` – `{string=}` -
             *
             *  - `marker` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "list": {
              url: urlBase + "/media-private/list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#newFolder
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Upload a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "newFolder": {
              url: urlBase + "/media-private/new-folder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#updateFile
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/media-private/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#updateFile
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/media-private/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#copyObject
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Copy an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "copyObject": {
              url: urlBase + "/media-private/copy-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#moveObject
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Move an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "moveObject": {
              url: urlBase + "/media-private/move-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#uploadFile
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/media-private/upload-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#uploadFiles
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Upload an array of files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "uploadFiles": {
              url: urlBase + "/media-private/upload-files",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#searchKeywords
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Get search keywords for fuzzy search on the client side
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "searchKeywords": {
              isArray: true,
              url: urlBase + "/media-private/search-keywords",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Media_Private#search
             * @methodOf lbServices.Media_Private
             *
             * @description
             *
             * Search for a page using fuzzy search capabilities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `text` – `{string}` -
             *
             *  - `keywords` – `{*}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Media_Private` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/media-private/search",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Media_Private#modelName
        * @propertyOf lbServices.Media_Private
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Media_Private`.
        */
        R.modelName = "Media_Private";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.API
 * @header lbServices.API
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `API` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "API",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/api/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.API#model
             * @methodOf lbServices.API
             *
             * @description
             *
             * Get API remote methods and schema from a specified model
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `project` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `API` object.)
             * </em>
             */
            "model": {
              url: urlBase + "/api/model",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.API#models
             * @methodOf lbServices.API
             *
             * @description
             *
             * Get API models
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `production` – `{boolean=}` -
             *
             *  - `project` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `API` object.)
             * </em>
             */
            "models": {
              url: urlBase + "/api/models",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.API#modelName
        * @propertyOf lbServices.API
        * @description
        * The name of the model represented by this $resource,
        * i.e. `API`.
        */
        R.modelName = "API";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Data_Local
 * @header lbServices.Data_Local
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Data_Local` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Data_Local",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/data-local/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#loadCommit
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/data-local/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#loadOne
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Load Project Data with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/data-local/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#delete
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/data-local/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#save
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Save project data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/data-local/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#new
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `title` – `{string}` -
             *
             *  - `path` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/data-local/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#loadMany
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Load all pages with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/data-local/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#loadTemplate
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/data-local/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Local#loadTemplates
             * @methodOf lbServices.Data_Local
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Local` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/data-local/load-templates",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Data_Local#modelName
        * @propertyOf lbServices.Data_Local
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Data_Local`.
        */
        R.modelName = "Data_Local";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Data_Remote
 * @header lbServices.Data_Remote
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Data_Remote` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Data_Remote",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/data-remote/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#loadCommit
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/data-remote/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#loadOne
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Load Project Data with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/data-remote/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#delete
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/data-remote/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#save
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Save project data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/data-remote/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#new
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/data-remote/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#loadMany
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Load all remote data with specified template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `order` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/data-remote/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#loadTemplate
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/data-remote/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Data_Remote#loadTemplates
             * @methodOf lbServices.Data_Remote
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Data_Remote` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/data-remote/load-templates",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Data_Remote#modelName
        * @propertyOf lbServices.Data_Remote
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Data_Remote`.
        */
        R.modelName = "Data_Remote";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Utility
 * @header lbServices.Utility
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Utility` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Utility",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/utility/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Utility#state
             * @methodOf lbServices.Utility
             *
             * @description
             *
             * Get current state of the utility
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Utility` object.)
             * </em>
             */
            "state": {
              url: urlBase + "/utility/state",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Utility#start
             * @methodOf lbServices.Utility
             *
             * @description
             *
             * Start a utility
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Utility` object.)
             * </em>
             */
            "start": {
              url: urlBase + "/utility/start",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Utility#modelName
        * @propertyOf lbServices.Utility
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Utility`.
        */
        R.modelName = "Utility";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GIT
 * @header lbServices.GIT
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GIT` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GIT",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/git/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.GIT#push
             * @methodOf lbServices.GIT
             *
             * @description
             *
             * Commit and push GIT changes
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `message` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GIT` object.)
             * </em>
             */
            "push": {
              url: urlBase + "/git/push",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GIT#status
             * @methodOf lbServices.GIT
             *
             * @description
             *
             * Get GIT Status
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GIT` object.)
             * </em>
             */
            "status": {
              url: urlBase + "/git/status",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.GIT#modelName
        * @propertyOf lbServices.GIT
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GIT`.
        */
        R.modelName = "GIT";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Role_Administrator
 * @header lbServices.Production_Role_Administrator
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Role_Administrator` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Role_Administrator",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-role-administrator/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Production_Role_Administrator.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/production-role-administrator/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Administrator#me
             * @methodOf lbServices.Production_Role_Administrator
             *
             * @description
             *
             * Get user's administrative settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Administrator` object.)
             * </em>
             */
            "me": {
              url: urlBase + "/production-role-administrator/me",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.administrator() instead.
            "::get::Production_Account::administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.administrator.create() instead.
            "::create::Production_Account::administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.administrator.createMany() instead.
            "::createMany::Production_Account::administrator": {
              isArray: true,
              url: urlBase + "/production-account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.administrator.update() instead.
            "::update::Production_Account::administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.administrator.destroy() instead.
            "::destroy::Production_Account::administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Role_Administrator#modelName
        * @propertyOf lbServices.Production_Role_Administrator
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Role_Administrator`.
        */
        R.modelName = "Production_Role_Administrator";


            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Administrator#account
             * @methodOf lbServices.Production_Role_Administrator
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Role_Administrator id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Production_Account");
          var action = TargetResource["::get::Production_Role_Administrator::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Role_Account_Manager
 * @header lbServices.Production_Role_Account_Manager
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Role_Account_Manager` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Role_Account_Manager",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-role-account-manager/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Production_Role_Account_Manager.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/production-role-account-manager/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#activate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "activate": {
              url: urlBase + "/production-role-account-manager/activate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#activities
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get latest activities of a specified account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `skip` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "activities": {
              url: urlBase + "/production-role-account-manager/activities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#changePassword
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Change password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "changePassword": {
              url: urlBase + "/production-role-account-manager/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#clearLimits
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Clear account limits
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "clearLimits": {
              url: urlBase + "/production-role-account-manager/clear-limits",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#deactivate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Deactivate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "deactivate": {
              url: urlBase + "/production-role-account-manager/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#filter
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Filter accounts by given options
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "filter": {
              url: urlBase + "/production-role-account-manager/filter",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#get
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get user's administrative settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "get": {
              url: urlBase + "/production-role-account-manager/get",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#new
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Create user with email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/production-role-account-manager/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#recent
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get recently created accounts
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `limit` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "recent": {
              url: urlBase + "/production-role-account-manager/recent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#search
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Find a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/production-role-account-manager/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#total
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get number of accounts created
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "total": {
              url: urlBase + "/production-role-account-manager/total",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#update
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "update": {
              url: urlBase + "/production-role-account-manager/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#tokenList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * List all tokens of the specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "tokenList": {
              url: urlBase + "/production-role-account-manager/token-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#tokenRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Remove a token of the specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "tokenRemove": {
              url: urlBase + "/production-role-account-manager/token-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#certAdd
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "certAdd": {
              url: urlBase + "/production-role-account-manager/cert-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#certList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * List the certificates of a specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "certList": {
              url: urlBase + "/production-role-account-manager/cert-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#certRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Remove a certificate from a scpecified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `certId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "certRemove": {
              url: urlBase + "/production-role-account-manager/cert-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#certUpdate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "certUpdate": {
              url: urlBase + "/production-role-account-manager/cert-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#ipAdd
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Add an IP to whitelist when loging in
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `title` – `{string}` -
             *
             *  - `address` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "ipAdd": {
              url: urlBase + "/production-role-account-manager/ip-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#ipList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * List the ip whitelist of a specified account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "ipList": {
              url: urlBase + "/production-role-account-manager/ip-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#ipRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Remove an IP from the account's whitelist
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `ipId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "ipRemove": {
              url: urlBase + "/production-role-account-manager/ip-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#sshAdd
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `title` – `{string}` -
             *
             *  - `content` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "sshAdd": {
              url: urlBase + "/production-role-account-manager/ssh-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#sshList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Activate Account with given ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "sshList": {
              url: urlBase + "/production-role-account-manager/ssh-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#sshRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Remove SSH Key from account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `keyId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "sshRemove": {
              url: urlBase + "/production-role-account-manager/ssh-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#roleAdd
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "roleAdd": {
              url: urlBase + "/production-role-account-manager/role-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#roleEdit
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `roleName` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "roleEdit": {
              url: urlBase + "/production-role-account-manager/role-edit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#roleGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `roleName` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "roleGet": {
              url: urlBase + "/production-role-account-manager/role-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#roles
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get all roles an account can have
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "roles": {
              isArray: true,
              url: urlBase + "/production-role-account-manager/roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#roleRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "roleRemove": {
              url: urlBase + "/production-role-account-manager/role-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#mediaUpload
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "mediaUpload": {
              url: urlBase + "/production-role-account-manager/media-upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#mediaGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `location` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "mediaGet": {
              url: urlBase + "/production-role-account-manager/media-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#mediaUpdate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `location` – `{string}` -
             *
             *  - `privacy` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "mediaUpdate": {
              url: urlBase + "/production-role-account-manager/media-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#teamMemberUpdate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "teamMemberUpdate": {
              url: urlBase + "/production-role-account-manager/team-member-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#teamMemberGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "teamMemberGet": {
              url: urlBase + "/production-role-account-manager/team-member-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#memberGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Topup account with coins
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "memberGet": {
              url: urlBase + "/production-role-account-manager/member-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#topupGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "topupGet": {
              url: urlBase + "/production-role-account-manager/topup-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#topupSubmit
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Topup account with coins
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             *  - `amount` – `{number=}` -
             *
             *  - `coins` – `{number}` -
             *
             *  - `free` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "topupSubmit": {
              url: urlBase + "/production-role-account-manager/topup-submit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#topupList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "topupList": {
              url: urlBase + "/production-role-account-manager/topup-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#topupRemove
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Cancel a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "topupRemove": {
              url: urlBase + "/production-role-account-manager/topup-remove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#topupRecover
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Recover a topup from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "topupRecover": {
              url: urlBase + "/production-role-account-manager/topup-recover",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#usageList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "usageList": {
              url: urlBase + "/production-role-account-manager/usage-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#invoiceGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get a invoice from a customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "invoiceGet": {
              url: urlBase + "/production-role-account-manager/invoice-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#invoiceList
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get invoices from customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "invoiceList": {
              url: urlBase + "/production-role-account-manager/invoice-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#invoicePaymentAdd
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Update a invoice
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `invoiceId` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `amount` – `{number}` -
             *
             *  - `currency` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "invoicePaymentAdd": {
              url: urlBase + "/production-role-account-manager/invoice-payment-add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#invoicePaymentUpdate
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Cancel a payment invoice
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `status` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "invoicePaymentUpdate": {
              url: urlBase + "/production-role-account-manager/invoice-payment-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#customerGet
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Get customer details
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accountId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "customerGet": {
              url: urlBase + "/production-role-account-manager/customer-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#customerAnalytics
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Analyze customer stats
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
            "customerAnalytics": {
              url: urlBase + "/production-role-account-manager/customer-analytics",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.account_manager() instead.
            "::get::Production_Account::account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.account_manager.create() instead.
            "::create::Production_Account::account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.account_manager.createMany() instead.
            "::createMany::Production_Account::account_manager": {
              isArray: true,
              url: urlBase + "/production-account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.account_manager.update() instead.
            "::update::Production_Account::account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.account_manager.destroy() instead.
            "::destroy::Production_Account::account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Role_Account_Manager#modelName
        * @propertyOf lbServices.Production_Role_Account_Manager
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Role_Account_Manager`.
        */
        R.modelName = "Production_Role_Account_Manager";


            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Account_Manager#account
             * @methodOf lbServices.Production_Role_Account_Manager
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Role_Account_Manager id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Production_Account");
          var action = TargetResource["::get::Production_Role_Account_Manager::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Role_Team_Member
 * @header lbServices.Production_Role_Team_Member
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Role_Team_Member` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Role_Team_Member",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-role-team-member/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Production_Role_Team_Member.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/production-role-team-member/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.team_member() instead.
            "::get::Production_Account::team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.team_member.create() instead.
            "::create::Production_Account::team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.team_member.createMany() instead.
            "::createMany::Production_Account::team_member": {
              isArray: true,
              url: urlBase + "/production-account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.team_member.update() instead.
            "::update::Production_Account::team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.team_member.destroy() instead.
            "::destroy::Production_Account::team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Role_Team_Member#modelName
        * @propertyOf lbServices.Production_Role_Team_Member
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Role_Team_Member`.
        */
        R.modelName = "Production_Role_Team_Member";


            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Team_Member#account
             * @methodOf lbServices.Production_Role_Team_Member
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Role_Team_Member id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Production_Account");
          var action = TargetResource["::get::Production_Role_Team_Member::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Role_Editor
 * @header lbServices.Production_Role_Editor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Role_Editor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Role_Editor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-role-editor/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Production_Role_Editor.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/production-role-editor/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Editor#contentChange
             * @methodOf lbServices.Production_Role_Editor
             *
             * @description
             *
             * Change content by given data
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Editor` object.)
             * </em>
             */
            "contentChange": {
              url: urlBase + "/production-role-editor/content-change",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.editor() instead.
            "::get::Production_Account::editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.editor.create() instead.
            "::create::Production_Account::editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.editor.createMany() instead.
            "::createMany::Production_Account::editor": {
              isArray: true,
              url: urlBase + "/production-account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.editor.update() instead.
            "::update::Production_Account::editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.editor.destroy() instead.
            "::destroy::Production_Account::editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Role_Editor#modelName
        * @propertyOf lbServices.Production_Role_Editor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Role_Editor`.
        */
        R.modelName = "Production_Role_Editor";


            /**
             * @ngdoc method
             * @name lbServices.Production_Role_Editor#account
             * @methodOf lbServices.Production_Role_Editor
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Role_Editor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Production_Account");
          var action = TargetResource["::get::Production_Role_Editor::account"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Contact_Email
 * @header lbServices.Production_Contact_Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Contact_Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Contact_Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-contact-email/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#inboxList
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Return inbox
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `addressId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "inboxList": {
              url: urlBase + "/production-contact-email/inbox-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#inboxLoad
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Load email from inbox
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `emailId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "inboxLoad": {
              url: urlBase + "/production-contact-email/inbox-load",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#inboxAccounts
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Return inbox accounts
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "inboxAccounts": {
              url: urlBase + "/production-contact-email/inbox-accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#templateList
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Return all email templates
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "templateList": {
              url: urlBase + "/production-contact-email/template-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#templateRender
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Render an email template
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `lng` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "templateRender": {
              url: urlBase + "/production-contact-email/template-render",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Contact_Email#send
             * @methodOf lbServices.Production_Contact_Email
             *
             * @description
             *
             * Send an email to a contact
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `to` – `{*}` -
             *
             *  - `subject` – `{string=}` -
             *
             *  - `message` – `{string}` -
             *
             *  - `attachments` – `{*=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Contact_Email` object.)
             * </em>
             */
            "send": {
              url: urlBase + "/production-contact-email/send",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Contact_Email#modelName
        * @propertyOf lbServices.Production_Contact_Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Contact_Email`.
        */
        R.modelName = "Production_Contact_Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Account
 * @header lbServices.Production_Account
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Account` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Account",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-account/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Production_Account.administrator() instead.
            "prototype$__get__administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.administrator.create() instead.
            "prototype$__create__administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.administrator.update() instead.
            "prototype$__update__administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.administrator.destroy() instead.
            "prototype$__destroy__administrator": {
              url: urlBase + "/production-account/:id/administrator",
              method: "DELETE",
            },

            // INTERNAL. Use Production_Account.account_manager() instead.
            "prototype$__get__account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.account_manager.create() instead.
            "prototype$__create__account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.account_manager.update() instead.
            "prototype$__update__account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.account_manager.destroy() instead.
            "prototype$__destroy__account_manager": {
              url: urlBase + "/production-account/:id/account_manager",
              method: "DELETE",
            },

            // INTERNAL. Use Production_Account.team_member() instead.
            "prototype$__get__team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.team_member.create() instead.
            "prototype$__create__team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.team_member.update() instead.
            "prototype$__update__team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.team_member.destroy() instead.
            "prototype$__destroy__team_member": {
              url: urlBase + "/production-account/:id/team_member",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#prototype$__get__reviewer
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Fetches hasOne relation reviewer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "prototype$__get__reviewer": {
              url: urlBase + "/production-account/:id/reviewer",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#prototype$__create__reviewer
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Creates a new instance in reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "prototype$__create__reviewer": {
              url: urlBase + "/production-account/:id/reviewer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#prototype$__update__reviewer
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Update reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "prototype$__update__reviewer": {
              url: urlBase + "/production-account/:id/reviewer",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#prototype$__destroy__reviewer
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Deletes reviewer of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroy__reviewer": {
              url: urlBase + "/production-account/:id/reviewer",
              method: "DELETE",
            },

            // INTERNAL. Use Production_Account.editor() instead.
            "prototype$__get__editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "GET",
            },

            // INTERNAL. Use Production_Account.editor.create() instead.
            "prototype$__create__editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "POST",
            },

            // INTERNAL. Use Production_Account.editor.update() instead.
            "prototype$__update__editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "PUT",
            },

            // INTERNAL. Use Production_Account.editor.destroy() instead.
            "prototype$__destroy__editor": {
              url: urlBase + "/production-account/:id/editor",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#login
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/production-account/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#logout
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/production-account/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#prototype$verify
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/production-account/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#confirm
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/production-account/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#resetPassword
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/production-account/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#changePassword
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/production-account/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#setPassword
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/production-account/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#hasRoles
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Check if a user has any of the requested roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roles` – `{*}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "hasRoles": {
              url: urlBase + "/production-account/has-roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#activities
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Get latest activities of authenticated user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `skip` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "activities": {
              url: urlBase + "/production-account/activities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#passwordChange
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Change password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password_old` – `{string=}` -
             *
             *  - `password_new` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "passwordChange": {
              url: urlBase + "/production-account/password-change",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#deactivate
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "deactivate": {
              url: urlBase + "/production-account/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#me
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * View current user profile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "me": {
              url: urlBase + "/production-account/me",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#recover
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "recover": {
              url: urlBase + "/production-account/recover",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#requestPassword
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `callback` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "requestPassword": {
              url: urlBase + "/production-account/request-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#requestRecovery
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Deactivate an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "requestRecovery": {
              url: urlBase + "/production-account/request-recovery",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#resendVerification
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Send verification letter to the given email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "resendVerification": {
              url: urlBase + "/production-account/resend-verification",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#signedIn
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Check if user is signed in.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "signedIn": {
              url: urlBase + "/production-account/signed-in",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#signIn
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Login account using email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string=}` -
             *
             *  - `username` – `{string=}` -
             *
             *  - `password` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "signIn": {
              url: urlBase + "/production-account/sign-in",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#signOut
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Logout a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "signOut": {
              url: urlBase + "/production-account/sign-out",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#signOutAll
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Clear all tokens from this account
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "signOutAll": {
              url: urlBase + "/production-account/sign-out-all",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#roleList
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "roleList": {
              url: urlBase + "/production-account/role-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#roleGet
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roleName` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "roleGet": {
              url: urlBase + "/production-account/role-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#verifyEmail
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Confirm a account registration with uid verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "verifyEmail": {
              url: urlBase + "/production-account/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#mediaUpdate
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Set privacy for account media file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `privacy` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "mediaUpdate": {
              url: urlBase + "/production-account/media-privacy",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#mediaUpload
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Upload an account media file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "mediaUpload": {
              url: urlBase + "/production-account/media-upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#mediaGet
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Get a media file from an account
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `type` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "mediaGet": {
              url: urlBase + "/production-account/media-get",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#update
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Account` object.)
             * </em>
             */
            "update": {
              url: urlBase + "/production-account/update",
              method: "POST",
            },

            // INTERNAL. Use Production_Role_Administrator.account() instead.
            "::get::Production_Role_Administrator::account": {
              url: urlBase + "/production-role-administrator/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Production_Role_Account_Manager.account() instead.
            "::get::Production_Role_Account_Manager::account": {
              url: urlBase + "/production-role-account-manager/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Production_Role_Team_Member.account() instead.
            "::get::Production_Role_Team_Member::account": {
              url: urlBase + "/production-role-team-member/:id/account",
              method: "GET",
            },

            // INTERNAL. Use Production_Role_Editor.account() instead.
            "::get::Production_Role_Editor::account": {
              url: urlBase + "/production-role-editor/:id/account",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Account#getCurrent
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/production-account" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



        /**
         * @ngdoc method
         * @name lbServices.Production_Account#getCachedCurrent
         * @methodOf lbServices.Production_Account
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Production_Account#login} or
         * {@link lbServices.Production_Account#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Production_Account instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Production_Account#isAuthenticated
         * @methodOf lbServices.Production_Account
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Production_Account#getCurrentId
         * @methodOf lbServices.Production_Account
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Production_Account#modelName
        * @propertyOf lbServices.Production_Account
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Account`.
        */
        R.modelName = "Production_Account";

    /**
     * @ngdoc object
     * @name lbServices.Production_Account.administrator
     * @header lbServices.Production_Account.administrator
     * @object
     * @description
     *
     * The object `Production_Account.administrator` groups methods
     * manipulating `Production_Role_Administrator` instances related to `Production_Account`.
     *
     * Call {@link lbServices.Production_Account#administrator Production_Account.administrator()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Production_Account#administrator
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Fetches hasOne relation administrator.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Administrator` object.)
             * </em>
             */
        R.administrator = function() {
          var TargetResource = $injector.get("Production_Role_Administrator");
          var action = TargetResource["::get::Production_Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.administrator#create
             * @methodOf lbServices.Production_Account.administrator
             *
             * @description
             *
             * Creates a new instance in administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Administrator` object.)
             * </em>
             */
        R.administrator.create = function() {
          var TargetResource = $injector.get("Production_Role_Administrator");
          var action = TargetResource["::create::Production_Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.administrator#createMany
             * @methodOf lbServices.Production_Account.administrator
             *
             * @description
             *
             * Creates a new instance in administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Administrator` object.)
             * </em>
             */
        R.administrator.createMany = function() {
          var TargetResource = $injector.get("Production_Role_Administrator");
          var action = TargetResource["::createMany::Production_Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.administrator#destroy
             * @methodOf lbServices.Production_Account.administrator
             *
             * @description
             *
             * Deletes administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.administrator.destroy = function() {
          var TargetResource = $injector.get("Production_Role_Administrator");
          var action = TargetResource["::destroy::Production_Account::administrator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.administrator#update
             * @methodOf lbServices.Production_Account.administrator
             *
             * @description
             *
             * Update administrator of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Administrator` object.)
             * </em>
             */
        R.administrator.update = function() {
          var TargetResource = $injector.get("Production_Role_Administrator");
          var action = TargetResource["::update::Production_Account::administrator"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Production_Account.account_manager
     * @header lbServices.Production_Account.account_manager
     * @object
     * @description
     *
     * The object `Production_Account.account_manager` groups methods
     * manipulating `Production_Role_Account_Manager` instances related to `Production_Account`.
     *
     * Call {@link lbServices.Production_Account#account_manager Production_Account.account_manager()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Production_Account#account_manager
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Fetches hasOne relation account_manager.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager = function() {
          var TargetResource = $injector.get("Production_Role_Account_Manager");
          var action = TargetResource["::get::Production_Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.account_manager#create
             * @methodOf lbServices.Production_Account.account_manager
             *
             * @description
             *
             * Creates a new instance in account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.create = function() {
          var TargetResource = $injector.get("Production_Role_Account_Manager");
          var action = TargetResource["::create::Production_Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.account_manager#createMany
             * @methodOf lbServices.Production_Account.account_manager
             *
             * @description
             *
             * Creates a new instance in account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.createMany = function() {
          var TargetResource = $injector.get("Production_Role_Account_Manager");
          var action = TargetResource["::createMany::Production_Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.account_manager#destroy
             * @methodOf lbServices.Production_Account.account_manager
             *
             * @description
             *
             * Deletes account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.account_manager.destroy = function() {
          var TargetResource = $injector.get("Production_Role_Account_Manager");
          var action = TargetResource["::destroy::Production_Account::account_manager"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.account_manager#update
             * @methodOf lbServices.Production_Account.account_manager
             *
             * @description
             *
             * Update account_manager of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Account_Manager` object.)
             * </em>
             */
        R.account_manager.update = function() {
          var TargetResource = $injector.get("Production_Role_Account_Manager");
          var action = TargetResource["::update::Production_Account::account_manager"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Production_Account.team_member
     * @header lbServices.Production_Account.team_member
     * @object
     * @description
     *
     * The object `Production_Account.team_member` groups methods
     * manipulating `Production_Role_Team_Member` instances related to `Production_Account`.
     *
     * Call {@link lbServices.Production_Account#team_member Production_Account.team_member()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Production_Account#team_member
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Fetches hasOne relation team_member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Team_Member` object.)
             * </em>
             */
        R.team_member = function() {
          var TargetResource = $injector.get("Production_Role_Team_Member");
          var action = TargetResource["::get::Production_Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.team_member#create
             * @methodOf lbServices.Production_Account.team_member
             *
             * @description
             *
             * Creates a new instance in team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Team_Member` object.)
             * </em>
             */
        R.team_member.create = function() {
          var TargetResource = $injector.get("Production_Role_Team_Member");
          var action = TargetResource["::create::Production_Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.team_member#createMany
             * @methodOf lbServices.Production_Account.team_member
             *
             * @description
             *
             * Creates a new instance in team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Team_Member` object.)
             * </em>
             */
        R.team_member.createMany = function() {
          var TargetResource = $injector.get("Production_Role_Team_Member");
          var action = TargetResource["::createMany::Production_Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.team_member#destroy
             * @methodOf lbServices.Production_Account.team_member
             *
             * @description
             *
             * Deletes team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.team_member.destroy = function() {
          var TargetResource = $injector.get("Production_Role_Team_Member");
          var action = TargetResource["::destroy::Production_Account::team_member"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.team_member#update
             * @methodOf lbServices.Production_Account.team_member
             *
             * @description
             *
             * Update team_member of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Team_Member` object.)
             * </em>
             */
        R.team_member.update = function() {
          var TargetResource = $injector.get("Production_Role_Team_Member");
          var action = TargetResource["::update::Production_Account::team_member"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Production_Account.editor
     * @header lbServices.Production_Account.editor
     * @object
     * @description
     *
     * The object `Production_Account.editor` groups methods
     * manipulating `Production_Role_Editor` instances related to `Production_Account`.
     *
     * Call {@link lbServices.Production_Account#editor Production_Account.editor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Production_Account#editor
             * @methodOf lbServices.Production_Account
             *
             * @description
             *
             * Fetches hasOne relation editor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Editor` object.)
             * </em>
             */
        R.editor = function() {
          var TargetResource = $injector.get("Production_Role_Editor");
          var action = TargetResource["::get::Production_Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.editor#create
             * @methodOf lbServices.Production_Account.editor
             *
             * @description
             *
             * Creates a new instance in editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Editor` object.)
             * </em>
             */
        R.editor.create = function() {
          var TargetResource = $injector.get("Production_Role_Editor");
          var action = TargetResource["::create::Production_Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.editor#createMany
             * @methodOf lbServices.Production_Account.editor
             *
             * @description
             *
             * Creates a new instance in editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Editor` object.)
             * </em>
             */
        R.editor.createMany = function() {
          var TargetResource = $injector.get("Production_Role_Editor");
          var action = TargetResource["::createMany::Production_Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.editor#destroy
             * @methodOf lbServices.Production_Account.editor
             *
             * @description
             *
             * Deletes editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.editor.destroy = function() {
          var TargetResource = $injector.get("Production_Role_Editor");
          var action = TargetResource["::destroy::Production_Account::editor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Production_Account.editor#update
             * @methodOf lbServices.Production_Account.editor
             *
             * @description
             *
             * Update editor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Production_Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Role_Editor` object.)
             * </em>
             */
        R.editor.update = function() {
          var TargetResource = $injector.get("Production_Role_Editor");
          var action = TargetResource["::update::Production_Account::editor"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Activity_Item
 * @header lbServices.Production_Activity_Item
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Activity_Item` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Activity_Item",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-activity-item/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Item#details
             * @methodOf lbServices.Production_Activity_Item
             *
             * @description
             *
             * Get Activity by ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Item` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/production-activity-item/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Item#latest
             * @methodOf lbServices.Production_Activity_Item
             *
             * @description
             *
             * Get Latest number of activities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string=}` -
             *
             *  - `unit` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `skip` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             *  - `aggregate` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Item` object.)
             * </em>
             */
            "latest": {
              url: urlBase + "/production-activity-item/latest",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Activity_Item#modelName
        * @propertyOf lbServices.Production_Activity_Item
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Activity_Item`.
        */
        R.modelName = "Production_Activity_Item";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Activity_Feed
 * @header lbServices.Production_Activity_Feed
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Activity_Feed` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Activity_Feed",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-activity-feed/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Feed#getByType
             * @methodOf lbServices.Production_Activity_Feed
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Feed` object.)
             * </em>
             */
            "getByType": {
              isArray: true,
              url: urlBase + "/production-activity-feed/get-by-type",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Activity_Feed#modelName
        * @propertyOf lbServices.Production_Activity_Feed
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Activity_Feed`.
        */
        R.modelName = "Production_Activity_Feed";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Activity_Count
 * @header lbServices.Production_Activity_Count
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Activity_Count` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Activity_Count",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-activity-count/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Count#details
             * @methodOf lbServices.Production_Activity_Count
             *
             * @description
             *
             * Get Count Details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Count` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/production-activity-count/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Count#totalsByType
             * @methodOf lbServices.Production_Activity_Count
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Count` object.)
             * </em>
             */
            "totalsByType": {
              url: urlBase + "/production-activity-count/totals-by-type",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Activity_Count#totals
             * @methodOf lbServices.Production_Activity_Count
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `feed` – `{string}` -
             *
             *  - `period` – `{string}` -
             *
             *  - `value` – `{number=}` -
             *
             *  - `year` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Activity_Count` object.)
             * </em>
             */
            "totals": {
              url: urlBase + "/production-activity-count/totals",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Activity_Count#modelName
        * @propertyOf lbServices.Production_Activity_Count
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Activity_Count`.
        */
        R.modelName = "Production_Activity_Count";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_System
 * @header lbServices.Production_System
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_System` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_System",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-system/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_System#clusters
             * @methodOf lbServices.Production_System
             *
             * @description
             *
             * Get clusters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_System` object.)
             * </em>
             */
            "clusters": {
              url: urlBase + "/production-system/clusters",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_System#modelName
        * @propertyOf lbServices.Production_System
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_System`.
        */
        R.modelName = "Production_System";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Process
 * @header lbServices.Production_Process
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Process` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Process",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-process/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Process#logs
             * @methodOf lbServices.Production_Process
             *
             * @description
             *
             * Get application logs
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Process` object.)
             * </em>
             */
            "logs": {
              url: urlBase + "/production-process/logs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Process#restart
             * @methodOf lbServices.Production_Process
             *
             * @description
             *
             * Restart system
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Process` object.)
             * </em>
             */
            "restart": {
              url: urlBase + "/production-process/restart",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Process#changesList
             * @methodOf lbServices.Production_Process
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Process` object.)
             * </em>
             */
            "changesList": {
              url: urlBase + "/production-process/changes-list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Process#changesRefresh
             * @methodOf lbServices.Production_Process
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Process` object.)
             * </em>
             */
            "changesRefresh": {
              url: urlBase + "/production-process/changes-refresh",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Process#modelName
        * @propertyOf lbServices.Production_Process
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Process`.
        */
        R.modelName = "Production_Process";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Page
 * @header lbServices.Production_Page
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Page` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Page",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-page/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadTemplate
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/production-page/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadTemplates
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/production-page/load-templates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadCommit
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/production-page/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadOne
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Load page with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/production-page/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#delete
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/production-page/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#save
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Save page data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/production-page/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#new
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `title` – `{string}` -
             *
             *  - `path` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/production-page/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadMany
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Load all pages by template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/production-page/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Page#loadTemplate
             * @methodOf lbServices.Production_Page
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Page` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/production-page/load-template",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Page#modelName
        * @propertyOf lbServices.Production_Page
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Page`.
        */
        R.modelName = "Production_Page";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Media
 * @header lbServices.Production_Media
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Media` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Media",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-media/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#deleteObject
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Delete an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "deleteObject": {
              url: urlBase + "/production-media/delete-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#details
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Get a file details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `location` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/production-media/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#list
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * List the files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `dir` – `{string=}` -
             *
             *  - `marker` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "list": {
              url: urlBase + "/production-media/list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#newFolder
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Upload a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "newFolder": {
              url: urlBase + "/production-media/new-folder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#updateFile
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/production-media/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#updateFile
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/production-media/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#copyObject
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Copy an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "copyObject": {
              url: urlBase + "/production-media/copy-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#moveObject
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Move an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "moveObject": {
              url: urlBase + "/production-media/move-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#uploadFile
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/production-media/upload-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media#uploadFiles
             * @methodOf lbServices.Production_Media
             *
             * @description
             *
             * Upload an array of files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media` object.)
             * </em>
             */
            "uploadFiles": {
              url: urlBase + "/production-media/upload-files",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Media#modelName
        * @propertyOf lbServices.Production_Media
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Media`.
        */
        R.modelName = "Production_Media";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Media_Private
 * @header lbServices.Production_Media_Private
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Media_Private` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Media_Private",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-media-private/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#deleteObject
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Delete an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "deleteObject": {
              url: urlBase + "/production-media-private/delete-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#details
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Get a file details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `location` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "details": {
              url: urlBase + "/production-media-private/details",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#list
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * List the files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `dir` – `{string=}` -
             *
             *  - `marker` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "list": {
              url: urlBase + "/production-media-private/list",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#newFolder
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Upload a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "newFolder": {
              url: urlBase + "/production-media-private/new-folder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#updateFile
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/production-media-private/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#updateFile
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Update a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `location` – `{string}` -
             *
             *  - `dir` – `{string=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `contentType` – `{string=}` -
             *
             *  - `privacy` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/production-media-private/update-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#copyObject
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Copy an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "copyObject": {
              url: urlBase + "/production-media-private/copy-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#moveObject
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Move an object
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `source` – `{string}` -
             *
             *  - `target` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "moveObject": {
              url: urlBase + "/production-media-private/move-object",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#uploadFile
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Upload a single file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/production-media-private/upload-file",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Media_Private#uploadFiles
             * @methodOf lbServices.Production_Media_Private
             *
             * @description
             *
             * Upload an array of files
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Media_Private` object.)
             * </em>
             */
            "uploadFiles": {
              url: urlBase + "/production-media-private/upload-files",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Media_Private#modelName
        * @propertyOf lbServices.Production_Media_Private
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Media_Private`.
        */
        R.modelName = "Production_Media_Private";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_API
 * @header lbServices.Production_API
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_API` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_API",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-api/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_API#model
             * @methodOf lbServices.Production_API
             *
             * @description
             *
             * Get API remote methods and schema from a specified model
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `project` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_API` object.)
             * </em>
             */
            "model": {
              url: urlBase + "/production-api/model",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_API#models
             * @methodOf lbServices.Production_API
             *
             * @description
             *
             * Get API models
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `production` – `{boolean=}` -
             *
             *  - `project` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_API` object.)
             * </em>
             */
            "models": {
              url: urlBase + "/production-api/models",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_API#modelName
        * @propertyOf lbServices.Production_API
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_API`.
        */
        R.modelName = "Production_API";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Data_Local
 * @header lbServices.Production_Data_Local
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Data_Local` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Data_Local",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-data-local/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#loadCommit
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/production-data-local/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#loadOne
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Load Project Data with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/production-data-local/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#delete
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/production-data-local/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#save
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Save project data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/production-data-local/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#new
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `title` – `{string}` -
             *
             *  - `path` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/production-data-local/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#loadMany
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Load all pages with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/production-data-local/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#loadTemplate
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/production-data-local/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Local#loadTemplates
             * @methodOf lbServices.Production_Data_Local
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Local` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/production-data-local/load-templates",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Data_Local#modelName
        * @propertyOf lbServices.Production_Data_Local
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Data_Local`.
        */
        R.modelName = "Production_Data_Local";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Data_Remote
 * @header lbServices.Production_Data_Remote
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Data_Remote` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Data_Remote",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-data-remote/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#loadCommit
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * load file add a specific commit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `commit` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "loadCommit": {
              url: urlBase + "/production-data-remote/load-commit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#loadOne
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Load Project Data with specified ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "loadOne": {
              url: urlBase + "/production-data-remote/load-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#delete
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Delete a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "delete": {
              url: urlBase + "/production-data-remote/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#save
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Save project data
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `template` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/production-data-remote/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#new
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Create new page
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "new": {
              url: urlBase + "/production-data-remote/new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#loadMany
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Load all remote data with specified template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `order` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "loadMany": {
              url: urlBase + "/production-data-remote/load-many",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#loadTemplate
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Load template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `template` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "loadTemplate": {
              url: urlBase + "/production-data-remote/load-template",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Data_Remote#loadTemplates
             * @methodOf lbServices.Production_Data_Remote
             *
             * @description
             *
             * Load all templates with optional limit
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Data_Remote` object.)
             * </em>
             */
            "loadTemplates": {
              url: urlBase + "/production-data-remote/load-templates",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Data_Remote#modelName
        * @propertyOf lbServices.Production_Data_Remote
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Data_Remote`.
        */
        R.modelName = "Production_Data_Remote";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_Utility
 * @header lbServices.Production_Utility
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_Utility` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_Utility",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-utility/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_Utility#state
             * @methodOf lbServices.Production_Utility
             *
             * @description
             *
             * Get current state of the utility
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Utility` object.)
             * </em>
             */
            "state": {
              url: urlBase + "/production-utility/state",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_Utility#start
             * @methodOf lbServices.Production_Utility
             *
             * @description
             *
             * Start a utility
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `name` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_Utility` object.)
             * </em>
             */
            "start": {
              url: urlBase + "/production-utility/start",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_Utility#modelName
        * @propertyOf lbServices.Production_Utility
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_Utility`.
        */
        R.modelName = "Production_Utility";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Production_GIT
 * @header lbServices.Production_GIT
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Production_GIT` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Production_GIT",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/production-git/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Production_GIT#push
             * @methodOf lbServices.Production_GIT
             *
             * @description
             *
             * Commit and push GIT changes
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `message` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_GIT` object.)
             * </em>
             */
            "push": {
              url: urlBase + "/production-git/push",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Production_GIT#status
             * @methodOf lbServices.Production_GIT
             *
             * @description
             *
             * Get GIT Status
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Production_GIT` object.)
             * </em>
             */
            "status": {
              url: urlBase + "/production-git/status",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Production_GIT#modelName
        * @propertyOf lbServices.Production_GIT
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Production_GIT`.
        */
        R.modelName = "Production_GIT";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$access_portal$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
